import React from 'react';

const F = "'Inter', system-ui, sans-serif";

export default function HighlightCard({ icon, title, text }) {
  return (
    <div style={styles.card}>
      <div style={styles.iconWrapper}>
        <span style={styles.icon}>{icon}</span>
      </div>
      <h3 style={styles.title}>{title}</h3>
      <p style={styles.text}>{text}</p>
    </div>
  );
}

const styles = {
  card: {
    backgroundColor: 'white',
    borderRadius: '16px',
    padding: '2rem 1.75rem',
    textAlign: 'center',
    boxShadow: '0 4px 24px rgba(0,0,0,0.07)',
    flex: '1 1 220px',
    transition: 'transform 0.2s, box-shadow 0.2s',
  },
  iconWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '60px',
    height: '60px',
    borderRadius: '14px',
    backgroundColor: '#f0fdf4',
    marginBottom: '1.1rem',
  },
  icon: { fontSize: '1.9rem', lineHeight: 1 },
  title: {
    color: '#0f172a',
    fontFamily: F,
    fontSize: '1rem',
    fontWeight: '700',
    marginBottom: '0.5rem',
    letterSpacing: '-0.1px',
  },
  text: {
    color: '#64748b',
    fontFamily: F,
    fontSize: '0.9rem',
    lineHeight: '1.65',
  },
};
